import React from "react";
import TrinsicStart from "../trinsic/TrinsicStart";
import BankIdLogo from "../../../assets/bankid_cz.svg";

const BankIdCzStart = () => {
  return (
    <TrinsicStart
      providerName="BANKID_CZ"
      providerDisplayName="BankID"
      logo={BankIdLogo}
      logoWidth={100}
      buttonColor="#262626"
    />
  );
};

export default BankIdCzStart;
